import Box from '@app/components/common/Box';
import Spinner from '@app/components/common/Spinner';
import { displayFlexRowCenterStyles } from '@app/theme/commonStyles';

interface ILoadingMore {
  children: React.ReactNode;
}

const LoadingMore = ({ children }: ILoadingMore) => {
  return (
    <Box
      csx={[
        displayFlexRowCenterStyles,
        {
          position: 'absolute',
          bottom: 10,
          left: 0,
          right: 0,
          width: '100%',
        },
      ]}>
      <Box
        csx={[
          displayFlexRowCenterStyles,
          {
            position: 'relative',
            opacity: 0.9,
            gap: 5,
            height: 45,
            backgroundColor: 'lightGrey',
            borderRadius: 20,
            padding: '10px 20px',
          },
        ]}>
        <Spinner size="30px" strokeWidth="7px" color="textWhite" />

        {children}
      </Box>
    </Box>
  );
};
export default LoadingMore;
